import React, { useRef, useContext, useState, useEffect } from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import bg from './Certificatebg.png'
import Arrow from './Arrow.png'
import { LanguageContext } from '../LanguageContext/LanguageContext';

const marketingBackendUrl = import.meta.env.VITE_MARKETING_BACKEND_URL;

const CertificateTemplate = ({ data }) => {
  const certificateRef = useRef();
  const { direction } = useContext(LanguageContext);
  const isRTL = direction === 'rtl';
  const [loading, setLoading] = useState(false);
  const email = localStorage.getItem("useremailidis");

  const handleCertificateGeneration = async () => {
    try {
      if (!email) {
        throw new Error('User email not found');
      }

      const checkResponse = await fetch(`${marketingBackendUrl}/maflam/certificate/student/${email}`);
      
      if (!checkResponse.ok) {
        throw new Error('Failed to check existing certificates');
      }

      const existingCertificates = await checkResponse.json();
   
      
      const existingCertificate = existingCertificates.find(cert => 
        cert.courseName === data.courseName && cert.studentEmail === email
      );

      if (existingCertificate) {

        return {
          success: true,
          certificateId: existingCertificate._id,
          generationDate: existingCertificate.generationDate
        };
      }

    
      const generateResponse = await fetch(`${marketingBackendUrl}/maflam/certificate/generate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          studentEmail: email,
          courseName: data.courseName
        })
      });

      if (!generateResponse.ok) {
        const errorData = await generateResponse.json();
        throw new Error(errorData.message || 'Failed to generate certificate');
      }

      const result = await generateResponse.json();

      return {
        success: true,
        certificateId: result.certificate._id,
        generationDate: result.certificate.generationDate
      };

    } catch (error) {
 
      return {
        success: false,
        message: error.message
      };
    }
  };

  const downloadCertificate = async () => {
    setLoading(true);
    try {
    
      
      // First generate/verify certificate in database
      const certificateResult = await handleCertificateGeneration();

      
      if (!certificateResult.success) {
        throw new Error('Failed to generate certificate');
      }


      // Then generate PDF
      const canvas = await html2canvas(certificateRef.current, {
        scale: 2,
        useCORS: true,
        backgroundColor: '#061C2B',
        width: 1280,
        height: 720
      });
      

      
      const imgData = canvas.toDataURL('image/jpeg', 1.0);
      
      const pdf = new jsPDF({
        orientation: 'landscape',
        unit: 'px',
        format: [1280, 720],
        hotfixes: ['px_scaling']
      });

      pdf.addImage(imgData, 'JPEG', 0, 0, 1280, 720);

      
      // Use certificate ID in filename
      pdf.save(`${data.name}_${certificateResult.certificateId}.pdf`);
  
      
    } catch (error) {
      console.error('Error in certificate download process:', error);
    } finally {
      setLoading(false);
      console.log('Certificate process completed');
    }
  };

  // Add this function to format the date
  const formatDate = (isRTL) => {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    const day = now.getDate();

    if (isRTL) {
      // Convert numbers to Arabic numerals
      const toArabicNumeral = (num) => {
        const arabicNumerals = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
        return num.toString().split('').map(digit => arabicNumerals[digit]).join('');
      };

      return `${toArabicNumeral(year)}/${toArabicNumeral(month)}/${toArabicNumeral(day)}`;
    }

    // Format for English: DD/MM/YYYY
    return `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
  };

  return (
    <div>
      {/* Loader */}
      {loading && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(57,255,251,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            width: '50px',
            height: '50px',
            border: '5px solid #fff',
            borderTop: '5px solid rgb(57,255,251)',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }} />
        </div>
      )}

      {/* Hidden Certificate for Capture */}
      <div 
        ref={certificateRef}
        style={{
          width: '1280px',
          height: '720px',
          backgroundColor: '#061C2B',
          backgroundImage: `url(${bg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          position: 'fixed',
          top: '-9999px',
          left: '-9999px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '40px',
          direction: isRTL ? 'rtl' : 'ltr',
        }}
      >
        {/* Logo at top right */}
        <div style={{
          position: 'absolute',
          top: '20px',
          right: '20px',
          width: '60px',
          height: '60px'
        }}>
          {/* Add your logo here */}
        </div>

        {/* Certificate Content */}
        <h1 style={{
          fontSize: '48px',
          color: 'white',
          marginBottom: '0px',
          fontWeight: 'bold'
        }}>
          {isRTL ?'شهــــــــادة إتمام ' : 'Certificate of Completion'}
        </h1>

        <p style={{
          fontSize: '24px',
          color: 'white',
          marginBottom: '15px'
        }}>
          {isRTL ? 'قدمت هذه الشهادة إلى' : 'This certificate is awarded to'}
        </p>

        <h2 style={{
          fontSize: '36px',
          color: 'white',
          marginBottom: '5px'
        }}>
          {data.name}
        </h2>

        {/* Line under name */}
        <div style={{
          width: '530px',
          height: '1px',
          background: '#5AFFFF',
          marginTop: '15px',
          marginBottom: '5px'
        }} />

        <div style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          marginBottom: '5px'
        }}>
          <p style={{
            fontSize: '24px',
            color: 'white',
            margin: 0
          }}>
            {isRTL ? 'لإكمال' : 'For completing the'}
          </p>
          
          <h3 style={{
            fontSize: '24px',
            color: 'white',
            margin: 0,
            fontWeight: 'bold'
          }}>
             {data.courseName }
          </h3>
        </div>

        <p style={{
          fontSize: '20px',
          color: 'white',
          marginTop: '5px'
        }}>
          {isRTL 
            ? `منحت بتاريخ ${formatDate(true)}` 
            : `Awarded on ${formatDate(false)}`
          }
        </p>

        {/* Decorative elements at bottom corners */}
      
      </div>

      {/* Download Button */}
      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <button 
          onClick={downloadCertificate}
          style={{ 
            height: '50px',
            width: '50px',
            backgroundColor: "transparent",
            borderRadius: '25px',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          <img style={{width: '50px', height: '50px'}} src={Arrow} alt="Download" />
        </button>
      </div>
    </div>
  );
};

export default CertificateTemplate; 